import { FormattedEvent, ShareUTMOptions } from '@eventbrite/consumer-search.event-renderer';
import React, { ReactElement } from 'react';
import { DiscoverVerticalEventCard } from '@eventbrite/consumer-search.discover-utils';
import styles from './ConsumerCards.module.scss';

type ConsumerCardsProps = Omit<
    EventCardGroupProps,
    'events' | 'containerClasses' | 'shareOptions'
> & {
    headerTitle?: ReactElement;
    bucketLayoutConfig?: {
        max: number;
        bucketClassNames: string;
        layout: { default: { containerClasses: string[] } };
    };
    eventGroups?: EventGroup[];
    enableInterestsSelector?: boolean;
    isForYouTabSelected?: boolean;
    showSaveAction?: boolean;
    showShareAction?: boolean;
};

interface EventGroup {
    events: FormattedEvent[];
    containerClasses: string;
}

function ConsumerCards({
    // TODO: update api to handle passing custom tracking labels
    headerTitle,
    bucketLayoutConfig,
    isAuthenticated,
    enableInterestsSelector,
    eventGroups = [],
    ...props
}: ConsumerCardsProps) {
    const bucketClassNames = (bucketLayoutConfig && bucketLayoutConfig.bucketClassNames) || '';

    return (
        <div className={bucketClassNames}>
            {headerTitle}
            <div className={styles.consumerCardsContainer}>
                {eventGroups.map(({ events, containerClasses }) => (
                    <EventCardGroup
                        key={events[0]?.id}
                        events={events}
                        containerClasses={containerClasses}
                        isAuthenticated={isAuthenticated}
                        {...props}
                    />
                ))}
            </div>
        </div>
    );
}

export type EventCardGroupProps = EventGroup & {
    bucketLabel?: string;
    isFreeTab?: boolean;
    statsigLocationString?: string;
    affCode?: string;
    locale: string;
    isAuthenticated?: boolean;
    showSaveAction?: boolean;
    showShareAction?: boolean;
};

const utmOptions: ShareUTMOptions = {
    'utm-campaign': 'social',
    'utm-content': 'attendeeshare',
    'utm-medium': 'discovery',
    'utm-term': 'listing',
    'utm-source': 'cp',
};

const shareOptions = { utmOptions };

function EventCardGroup({
    events,
    statsigLocationString,
    containerClasses,
    locale,
    isFreeTab,
    affCode = 'ebhometext',
    bucketLabel,
    isAuthenticated,
    showSaveAction = false,
    showShareAction = false,
}: EventCardGroupProps) {
    const linkTrackingMode = affCode === 'ehometext' ? 'canonical-safe-homepage' : undefined;

    return (
        <>
            {events.map((event) => {
                return (
                    <div className={`${containerClasses}`} key={event.id}>
                        <DiscoverVerticalEventCard
                            locale={locale || 'en_US'}
                            statsigLocationString={statsigLocationString}
                            isAuthenticated={isAuthenticated}
                            event={event}
                            /* FIXME make isLazyImage dynamic for SSR and consider next/image */
                            isLazyImage={false}
                            hidePriceDescription={isFreeTab}
                            affCode={affCode}
                            linkTrackingMode={linkTrackingMode}
                            data-testid={`home-event-card-${event.id}`}
                            bucketLabel={bucketLabel}
                            shareOptions={shareOptions}
                            showSaveAction={showSaveAction}
                            showShareAction={showShareAction}
                        />
                    </div>
                );
            })}
        </>
    );
}

export default ConsumerCards;
